import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/crystaSureLogo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-99248cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "navbar bg-white sticky z-50 top-0 left-0 flex shadow p-2" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"navbar-start\" data-v-99248cca><div class=\"w-40\" data-v-99248cca><div class=\"lg:flex\" data-v-99248cca><span class=\"text-lg font-bold cursor-pointer\" data-v-99248cca><img src=\"" + _imports_0 + "\" alt=\"\" class=\"crystallineLogo h-8\" data-v-99248cca></span></div></div></div>", 1)
const _hoisted_4 = { class: "navbar-center" }
const _hoisted_5 = { class: "items-center justify-center lg:flex" }
const _hoisted_6 = { class: "navbar-end" }
const _hoisted_7 = { class: "overflow-scroll h-screen" }
const _hoisted_8 = { class: "flex items-center flex-col p-2" }
const _hoisted_9 = { class: "modules" }
const _hoisted_10 = { class: "maincontainer flex flex-col items-center p-2" }
const _hoisted_11 = { class: "parent-carousel" }
const _hoisted_12 = { class: "flex justify-end text-sm font-semibold screens" }
const _hoisted_13 = { class: "controls" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "42",
  height: "42",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "30",
    cy: "30",
    r: "30",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M35.4344 19.5235C35.2328 18.9094 34.8438 18.4594 34.2859 18.1922C33.9719 18.0469 33.8781 18.0235 33.4844 18.0094C32.9781 17.986 32.6688 18.0563 32.2891 18.2766C32.0641 18.4079 21.5734 27.8672 21.0719 28.3875C20.6406 28.8422 20.5 29.2313 20.5 30C20.5 30.7688 20.6406 31.1579 21.0719 31.6125C21.5734 32.1375 32.0641 41.5922 32.2891 41.7235C32.6688 41.9438 32.9781 42.0141 33.4844 41.9907C33.8781 41.9766 33.9719 41.9532 34.2859 41.8079C34.75 41.5829 35.0828 41.2547 35.3078 40.786C35.4719 40.4391 35.4766 40.411 35.4766 39.8907C35.4766 39.2672 35.3875 38.9766 35.0781 38.5875C34.9797 38.461 32.8328 36.4829 30.3016 34.1907C27.7703 31.8985 25.7031 30.0141 25.7031 30C25.7031 29.986 27.7703 28.1016 30.3016 25.8094C32.8328 23.5172 34.9797 21.5391 35.0781 21.4125C35.3594 21.0563 35.4672 20.7282 35.4859 20.1797C35.4906 19.8844 35.4766 19.6407 35.4344 19.5235Z",
    fill: "#4D4D4D"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "42",
  height: "42",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "30",
    cy: "30",
    r: "30",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.5656 40.4765C24.7672 41.0906 25.1562 41.5406 25.7141 41.8078C26.0281 41.9531 26.1219 41.9765 26.5156 41.9906C27.0219 42.014 27.3312 41.9437 27.7109 41.7234C27.9359 41.5921 38.4266 32.1328 38.9281 31.6125C39.3594 31.1578 39.5 30.7687 39.5 30C39.5 29.2312 39.3594 28.8421 38.9281 28.3875C38.4266 27.8625 27.9359 18.4078 27.7109 18.2765C27.3312 18.0562 27.0219 17.9859 26.5156 18.0093C26.1219 18.0234 26.0281 18.0468 25.7141 18.1921C25.25 18.4171 24.9172 18.7453 24.6922 19.214C24.5281 19.5609 24.5234 19.589 24.5234 20.1093C24.5234 20.7328 24.6125 21.0234 24.9219 21.4125C25.0203 21.539 27.1672 23.5171 29.6984 25.8093C32.2297 28.1015 34.2969 29.9859 34.2969 30C34.2969 30.014 32.2297 31.8984 29.6984 34.1906C27.1672 36.4828 25.0203 38.4609 24.9219 38.5875C24.6406 38.9437 24.5328 39.2718 24.5141 39.8203C24.5094 40.1156 24.5234 40.3593 24.5656 40.4765Z",
    fill: "#4D4D4D"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.courses.length > 0 && _ctx.slides.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.courses[0].courseName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btnprimary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExit()))
            }, "EXIT")
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, "Module " + _toDisplayString(_ctx.modulesIndex + 1) + " of " + _toDisplayString(_ctx.activemodules.length), 1),
            _createElementVNode("h1", null, _toDisplayString(_ctx.activemodules[_ctx.modulesIndex].moduleName), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.slides.length > 0)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTabComponent), _mergeProps({ key: 0 }, _ctx.currentProperties, {
                    currentModule: _ctx.currentModuleProperties,
                    onModule: _ctx.getModuleAction,
                    onVideo: _ctx.toggleNextButton,
                    key: _ctx.currentKey,
                    class: "card"
                  }), null, 16, ["currentModule", "onModule", "onVideo"]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_12, "Screen " + _toDisplayString(_ctx.slideIndex + 1) + " of " + _toDisplayString(_ctx.slides.length), 1),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.slideIndex != 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      role: "button",
                      "data-slide": "prev",
                      class: "carousel-control-prev",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveSlide('backward')))
                    }, _hoisted_16))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass({'inline':_ctx.nextButton,'hidden':!_ctx.nextButton})
                }, [
                  (_ctx.slideIndex != _ctx.slides.length - 1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        role: "button",
                        "data-slide": "next",
                        class: "carousel-control-next",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveSlide('forward')))
                      }, _hoisted_19))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}